// Implements: F-UIX-019
/**
 * One organization's row of the platform totals, and the state that belongs to it alone:
 * whether its detail is open. The view mounts it keyed by organization id (checklist 14),
 * so a new range that puts another organization where this one was mounts a fresh row,
 * and an organization's open detail never shows up on another's.
 */

import { useId, useState } from "react";
import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import { TotalsRow } from "../components/TotalsRow";
import { rowLabel } from "../model/platformRows";
import type { TotalsRow as Row } from "../model/platformRows";

export interface OrganizationRowContainerProps {
  readonly row: Row;
}

export function OrganizationRowContainer({ row }: OrganizationRowContainerProps): ReactElement {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const detailId = useId();
  return (
    <TotalsRow
      label={rowLabel(row, t("admin.totals.noOrganization"))}
      figures={row}
      expanded={expanded}
      detailId={detailId}
      onToggle={() => {
        setExpanded((open) => !open);
      }}
    />
  );
}
